// eslint-disable-next-line import/no-cycle
import { NumberFormat } from './core';
/**
 * Number.prototype.toLocaleString ponyfill
 * https://tc39.es/ecma402/#sup-number.prototype.tolocalestring
 */
export function toLocaleString(x, locales, options) {
    var numberFormat = new NumberFormat(locales, options);
    return numberFormat.format(x);
}
//# sourceMappingURL=to_locale_string.js.map